import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Form, Formik, ErrorMessage } from "formik";
import { forgotPasswordSchema } from '../../utils/yup';
import CloseIcon from "../icons/CloseIcon";
import { forgotPassword } from "../../redux/actions";
import { toast } from 'react-toastify';

const ForgotPasswordPage = () => { 
    const [loading, setLoading]  = useState(false);  
    const navigate               = useNavigate();  

    const onSubmit = async (values, { setSubmitting }) => {
        try {   
            setLoading(true);
            const result  = await forgotPassword(values.email);

            if(result?.status === 'success.password-reset-link-sent') {                
                navigate("/forgot-password-mail?email="+values.email);
            } else if(result?.errors?.email) { 
                toast.error(result?.errors?.email);
                navigate("/");
            }
            else { 
                navigate("/");
            }

            setLoading(false);
        } catch (error) {     
            setLoading(false);   
            console.log(error);  
        }

        setSubmitting(false);
    };   

    return (
        <section className="account py-40">
            <Formik
                initialValues={{
                    email      : ''                    
                }}
                onSubmit={onSubmit}
                validationSchema={forgotPasswordSchema}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                    <Form>
                        <div className="container container-lg">            
                            <div className="row gy-4">
                                {/* Confirm invitation Card Start */}
                                <div className="col-xl-3"></div>
                                <div className="col-xl-5">
                                    <div className="row gy-4">
                                        <div className="col-xl-6">
                                            <div className="logo px-16 d-block">
                                                <Link to='/' className='mobile-menu__logo'>
                                                    <img src='../../assets/images/logo/dhofar-logo.svg' alt='Logo' />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 d-flex justify-content-end align-items-center">
                                            <Link to='/'>
                                                <CloseIcon size={14} className='text-neutral-900' />
                                            </Link>
                                        </div>
                                    </div>
                                    <h4 className="text-center"><b>Forgot Password?</b></h4>  
                                    <div className="product-dContent border rounded-24 p-20"> 
                                        <div className="mb-40">   
                                            <div className="mb-24">
                                                <div className="pt-20 pb-20">No worries, we’ll send you a link to reset your password.</div>
                                                    
                                                <label
                                                    htmlFor="emailTwo"
                                                    className="lable-font text-neutral-900 mb-8 fw-medium"
                                                >
                                                    E-mail address <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    className="common-input input-font"
                                                    placeholder="Enter email address"
                                                    name="email"
                                                    id="email"
                                                    onChange={(e) => {
                                                        handleChange(e); 
                                                    }}
                                                    onBlur={handleBlur}
                                                    value={values.email}  
                                                    autoComplete="off"                                                     
                                                />
                                                {errors.email && touched.email && (
                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                )}
                                            </div>                                                                                    
                                            <div className="text-center">
                                                <button type="submit" className="btn btn-main py-16 px-30 w-full" disabled={loading} >
                                                    Send Resend Link
                                                </button>
                                            </div>                                             
                                        </div>    
                                    </div>                         
                                </div>
                                {/* Confirm invitation Card End */}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </section>
    );
};

export default ForgotPasswordPage;
